import type { PotStatus, PotSummary } from '../types/pot.types';

/** A group of pots sharing the same status, ordered by {@link STATUS_ORDER}. */
export interface StatusGroup {
  status: PotStatus;
  pots: PotSummary[];
}

const STATUS_ORDER: PotStatus[] = [
  'Open',
  'Verifying',
  'MissedVerificationDeadline',
  'Verified',
  'Submitting',
  'Submitted',
  'MissedSubmitDeadline',
  'Approved',
  'Paid',
  'Rejected',
  'Archived',
];

export function groupPotsByStatus(pots: PotSummary[]): StatusGroup[] {
  const groupMap = new Map<PotStatus, PotSummary[]>();

  for (const pot of pots) {
    const existing = groupMap.get(pot.status);
    if (existing) {
      existing.push(pot);
    } else {
      groupMap.set(pot.status, [pot]);
    }
  }

  return STATUS_ORDER.filter(status => groupMap.has(status)).map(status => ({
    status,
    pots: groupMap.get(status)!,
  }));
}
